import { useMutation } from '@tanstack/react-query'
import { useIntl } from 'react-intl'
import { accountApi } from '@/api/accountApi'
import { getApiError } from '@/api/helpers/apiError'
import { useSession } from '@/session/SessionContext'
import { showToast } from '@/theme/notifications'

export const useLogout = (redirectToAfterLogin?: string) => {
  const intl = useIntl()
  const { clearSession } = useSession()

  const { mutateAsync } = useMutation({
    mutationFn: accountApi.logout,
    onSuccess: () => {
      clearSession({ logoutType: 'user_logout', redirectToAfterLogin }) // redirect to login page is handled in PrivateRoute
    },
    onError: (error) => {
      const { errorMessage } = getApiError(error)
      const message = errorMessage || intl.formatMessage({ id: 'logout.error' })
      showToast(message, 'error')
    }
  })

  return {
    logout: mutateAsync
  }
}
